import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ props: any }>()(
  (theme,{props}) => ({
  loader: {
    display: 'grid',
    height: props.height ?? '90vh',
    justifyContent: 'center',
    alignContent: 'center',
  },
}));
